import React, { Component, Fragment } from 'react';
import numeral from 'numeral';
import moment from 'moment';
import Button from '@material-ui/core/Button';
import DefaultModal from 'Modals/DefaultModal';
import getErrorsFromResponse from 'Components/Forms/Functions/getErrorsFromResponse';
import getFormStatus from 'Components/Forms/Functions/getFormStatus';
import Loader from 'Pure/Loader';
import PDFIcon from 'Icons/PDFIcon';
import bemit from 'Functions/bemit';
import { num, isTrue, formatNum } from 'Shared/utilities';
import { action, URL } from 'Shared/Routes';
const {
  qwest
} = window;
export default class CustomerBookingRow extends Component {
  state = {
    loading: false,
    modal: false
  };
  modal_ref = React.createRef();
  openModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      modal: true,
      modal_trigger: e?.target
    });
  };
  closeModal = e => {
    const component = this,
      props = this.props,
      state = this.state;
    component.setState({
      modal: false,
      modal_trigger: undefined
    });
  };
  cancel = () => {
    const component = this,
      props = this.props,
      state = this.state;
    if (state.loading) return;
    component.setState({
      loading: true
    });
    qwest.post(action('cancelBooking'), {
      id: props.data?.id
    }).then(function (xhr, response) {
      component.setState({
        loading: false
      });
      props.requestUpdate();
      component.modal_ref?.current?.click();
    }).catch(function (error, xhr, response) {
      console.error(response?.error || response?.raw || error);
      component.setState({
        ...getErrorsFromResponse({
          response: response
        })
      });
    });
  };
  render() {
    const component = this,
      props = this.props,
      state = this.state;
    const {
      data,
      blank = false,
      fields
    } = props;
    numeral.locale('en');
    moment.locale('fr');
    const loader = state.loading === true ? /*#__PURE__*/React.createElement(Loader, {
      className: "c-loader",
      bemit: ['white', 'bg-red']
    }) : undefined;
    const space = data.coworking_space || {};
    const limit_date = moment(data.date).add(data.start_hour, 'hour');
    if (space.type === 'b_seminar' && space.cancellation_condition === 'annulation_possible') {
      const days = num(space.cancellation_condition_duration, 0);
      limit_date.subtract(days, 'days');
    } else
      // can be refunded until 4h before booking date
      {
        limit_date.subtract(4, 'hours');
      }
    const is__half_type = ['b_seminar', 'c_open_coworking_space'].includes(data.coworking_space?.type);
    let can_cancel = (data.status === 'paid' || data.status === 'confirmed') && !moment().isSameOrAfter(limit_date);
    const base_total = num(data.amount);
    const base_services_price = (data.services || []).filter(row => row.payment_type !== 'add-services').reduce(function (total, row) {
      return num(total + num(row.total_price));
    }, 0);
    const services_price = (data.services || []).reduce(function (total, row) {
      if (isTrue(row.canceled)) return total;
      return num(total + num(row.total_price));
    }, 0);
    const discounted = num((data.discount_code || {}).discounted);
    const space_price = num(base_total - base_services_price + discounted);
    const grand_total = num(space_price - discounted + services_price);
    let output = /*#__PURE__*/React.createElement("div", {
      className: 'c-dashboard__row ' + 'Booking-' + data.status
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-date"
    }, moment(data.date).format('DD/MM/YYYY')), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-hours"
    }, is__half_type ? data.type === 'morning' ? 'Matin' : data.type === 'afternoon' ? 'Après midi' : 'La journée' : data.start_hour + 'h - ' + data.end_hour + 'h'), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-amount"
    }, grand_total > 0 ? formatNum(grand_total, '0,0[.]00') + '€' : undefined), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-coworking_space_name"
    }, data.coworking_space.name, ' - ', data?._etablishment?.name), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-address"
    }, data._etablishment?.address?.line_1, /*#__PURE__*/React.createElement("br", null), data._etablishment?.address?.line_2 ? /*#__PURE__*/React.createElement(Fragment, null, data._etablishment?.address?.line_2, /*#__PURE__*/React.createElement("br", null)) : undefined, [data._etablishment?.address?.postal_code, data._etablishment?.address?.city].filter(str => str).join(' ')), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-number_of_people"
    }, data.number_of_people), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-status"
    }, data.status === 'pending' ? 'Attente paiement' : data.status === 'paid' ? 'Réglée' : data.status === 'confirmed' ? 'Confirmée' : 'Annulée'), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-PDF"
    }, data.status === 'paid' ? /*#__PURE__*/React.createElement("a", {
      href: action('getBookingPDF').replace(':booking_id', data.id),
      target: "_blank",
      type: "application/pdf",
      rel: "noopener noreferrer",
      className: "c-dashboard__pdf-link"
    }, /*#__PURE__*/React.createElement(PDFIcon, {
      className: "c-dashboard__pdf-icon"
    })) : undefined), /*#__PURE__*/React.createElement("div", {
      className: "c-dashboard__cell Booking-actions"
    }, can_cancel ? /*#__PURE__*/React.createElement(Button, {
      className: bemit('c-flat-btn', ['primary', 'small']),
      onClick: component.openModal
    }, "Annuler") : undefined), /*#__PURE__*/React.createElement(DefaultModal, {
      open: state.modal,
      title: "Annulation de r\xE9servation",
      trigger_src: state.modal_trigger,
      "close-ref": component.modal_ref,
      "with-footer-close": false,
      "hide-controls": true,
      bemit: ['default', 'small'],
      onClose: component.closeModal
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message c-message--orange"
    }, /*#__PURE__*/React.createElement("div", {
      className: "c-message__content"
    }, "Annuler cette r\xE9servation\xA0? Cette action est d\xE9finitive.")), getFormStatus(state), /*#__PURE__*/React.createElement("div", {
      className: "c-modal__controls"
    }, /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn c-flat-btn--red u-margin-right-25",
      onClick: component.cancel
    }, loader, "Oui, Annuler"), /*#__PURE__*/React.createElement(Button, {
      color: "primary",
      className: "c-flat-btn",
      onClick: e => component.modal_ref?.current?.click()
    }, "Fermer"))));
    return output;
  }
}
